import { AdPlayerType, PlayerType } from '../builder-config';

export function determineAdPlayerType(playerType: PlayerType): AdPlayerType {
  return playerType === PlayerType.Bitmovin ? AdPlayerType.Bitmovin : AdPlayerType.Native;
}
